module.exports = __webpack_public_path__ + "img/top-follow@3x.64ead9ca.png";